import { getTabScope, getTabToken, getTokenKey } from '../stores/auth.store';

const normalizeRole = (role) => String(role || "").trim().toLowerCase();

// Only this tab's session: other tabs may be signed in as other roles.
export const getStoredToken = () => getTabToken();

export const getStoredUser = () => null;

export const getStoredUserIdentifier = () => {
  const user = getStoredUser();
  return (
    user?.id ||
    user?.user?.id ||
    user?.email ||
    user?.user?.email ||
    ""
  );
};

export const clearStoredAuth = () => {
  const scope = getTabScope();
  if (!scope) return;
  const key = getTokenKey(scope);
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

export const isAdminRole = (role) => {
  const normalized = normalizeRole(role);
  if (!normalized) return false;
  if (normalized.includes("admin")) return true;
  return ["super_admin", "superadmin"].includes(normalized);
};

export const isAssistantRole = (role) => {
  const normalized = normalizeRole(role);
  if (!normalized) return false;

  return [
    "assistant",
    "serviceprovider",
    "service_provider",
  ].includes(normalized);
};

const decodeJwtPayload = (token) => {
  if (typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = atob(padded);
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export const hasValidAuthSession = ({ clearExpired = false } = {}) => {
  const token = getStoredToken();
  if (!token) return false;

  const payload = decodeJwtPayload(token);
  const exp = Number(payload?.exp);

  if (!exp || Number.isNaN(exp)) {
    return true;
  }

  const isValid = exp * 1000 > Date.now();

  if (!isValid && clearExpired) {
    clearStoredAuth();
  }

  return isValid;
};

export const getStoredUserRole = () => {
  const user = getStoredUser();
  return user?.role || user?.user?.role || "";
};

export const getDashboardPath = () => {
  const role = getStoredUserRole();

  if (isAdminRole(role)) return "/admin";
  if (isAssistantRole(role)) return "/dashboards/assistant/overview";

  return "/user/travel-assistant";
};
